//import axios from 'axios';
import request from 'superagent'
import config from '../../src/config';

export const post = (url, body) => {
  const finalUrl = config.API_BASE + url;
  return new Promise((resolve) => {
    request
      .post(finalUrl)
      .send(body)
      .then(response => resolve(response))
      .catch(error => resolve(error.response));
  });
};

// export const post = (url, body) => {
//   const finalUrl = config.API_BASE + url;
//   return new Promise((resolve) => {
//     fetch(finalUrl, {
//       body: JSON.stringify(body),
//       method: 'POST', 
//       redirect: 'follow',
//     })
//       .then(response => resolve(response))
//       .catch(error => resolve(error.response));
//   });
// };

export const get = (url, param) => {
  // const finalUrl = config.API_BASE + url + param;
  //const finalUrl = config.API_BASE + url;
  return new Promise((resolve) => {
    request
      .get(url)
      .query(param)
      .then(response => resolve(response))
      .catch(error => resolve(error.response));
  });
};



// WEBPACK FOOTER //
// ./src/api/index.js